import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EmulatePhonePendingLinkClickResponse extends BackendResponse {}
export interface EmulatePhonePendingLinkClickParameters extends NextApiParams {}

export const emulatePhonePendingLinkClick = withNextApi<
  EmulatePhonePendingLinkClickResponse,
  EmulatePhonePendingLinkClickParameters
>("/cvp/CvpEmulatePhonePendingLinkClick");
